"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFeedback = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const tokens_1 = require("../../styles/tokens");
const FEEDBACK = {
    colours: {
        success: {
            backgroundColor: tokens_1.COLOURS.primary.green["10"],
            border: tokens_1.BORDERS.soft.green,
        },
        information: {
            backgroundColor: tokens_1.COLOURS.primary.blue["10"],
            border: tokens_1.BORDERS.soft.blue,
        },
        secondary: {
            backgroundColor: tokens_1.COLOURS.greyscale.white,
            border: tokens_1.BORDERS.soft.silver,
        },
        warning: {
            backgroundColor: tokens_1.COLOURS.primary.yellow["10"],
            border: tokens_1.BORDERS.soft.yellow,
        },
        error: {
            backgroundColor: tokens_1.COLOURS.primary.red["10"],
            border: tokens_1.BORDERS.soft.red,
        },
        learning: {
            backgroundColor: tokens_1.COLOURS.primary.purple["10"],
            border: tokens_1.BORDERS.soft.purple,
        },
    },
};
exports.StyledFeedback = styled_components_1.default.div `
    align-items: flex-start;
    border-radius: ${tokens_1.BORDERS.radius};
    box-sizing: border-box;
    display: flex;
    padding: ${tokens_1.SIZES["2"]};
    ${({ colour }) => FEEDBACK.colours[colour]}
`;
//# sourceMappingURL=Feedback.styles.js.map